"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPayrollProfileDto = instanceOfPayrollProfileDto;
exports.PayrollProfileDtoFromJSON = PayrollProfileDtoFromJSON;
exports.PayrollProfileDtoFromJSONTyped = PayrollProfileDtoFromJSONTyped;
exports.PayrollProfileDtoToJSON = PayrollProfileDtoToJSON;
exports.PayrollProfileDtoToJSONTyped = PayrollProfileDtoToJSONTyped;
const I9Status_1 = require("./I9Status");
/**
 * Check if a given object implements the PayrollProfileDto interface.
 */
function instanceOfPayrollProfileDto(value) {
    if (!('profileId' in value) || value['profileId'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('zealEmployeeId' in value) || value['zealEmployeeId'] === undefined)
        return false;
    if (!('onboarded' in value) || value['onboarded'] === undefined)
        return false;
    if (!('i9Status' in value) || value['i9Status'] === undefined)
        return false;
    if (!('isSalaried' in value) || value['isSalaried'] === undefined)
        return false;
    return true;
}
function PayrollProfileDtoFromJSON(json) {
    return PayrollProfileDtoFromJSONTyped(json, false);
}
function PayrollProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'profileId': json['profileId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'zealEmployeeId': json['zealEmployeeId'],
        'onboarded': json['onboarded'],
        'i9Status': (0, I9Status_1.I9StatusFromJSON)(json['i9Status']),
        'isSalaried': json['isSalaried'],
    };
}
function PayrollProfileDtoToJSON(json) {
    return PayrollProfileDtoToJSONTyped(json, false);
}
function PayrollProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'profileId': value['profileId'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'zealEmployeeId': value['zealEmployeeId'],
        'onboarded': value['onboarded'],
        'i9Status': (0, I9Status_1.I9StatusToJSON)(value['i9Status']),
        'isSalaried': value['isSalaried'],
    };
}
//# sourceMappingURL=PayrollProfileDto.js.map